// Kingdom manager — post-onboarding the active kingdom is bound to the
// player's home kingdom (profile.homeKingdom). Switching is gated behind
// defection (handled in profileManager). This module is mostly a read API.

import { KingdomOrder, KingdomConfig } from '../config/balance.js'
import { activeId, getKingdom } from './state.js'

export function isUnlocked() {
  // Every kingdom is viewable; gameplay is gated by profile.homeKingdom, not
  // by kingdom unlocks. Kept around for any old call sites still referencing it.
  return true
}

export function unlockCost() {
  return 0
}

export function unlockedCount() {
  return KingdomOrder.length
}

// Federation bonus is reserved for Phase 5.2+ when real cross-kingdom player
// data lands. For now it's a no-op multiplier so the yield/tax math stays simple.
export function getFederationBonus() {
  return 1.0
}

export function listKingdoms() {
  return KingdomOrder.map((id) => ({
    id,
    config: KingdomConfig[id],
    unlocked: true,
    active: id === activeId(),
  }))
}

export { getKingdom }
